<template>
  <div v-if="start">
    <div class="row mb-6">
      <div class="vx-col w-full md:w-12/12 lg:w-10/12">
        <vx-card>
          <div class="vx-row items-end">
            <div class="vx-col w-full lg:w-5/12 mb-6 lg:mb-0">
              <div class="vs-input--label">Канал:</div>
              <v-select
                :clearable="false"
                label="name"
                v-model="currentFilters.channel"
                :reduce="option => option.slug"
                :options="channels"
              />
            </div>
            <div class="vx-col w-full lg:w-4/12 mb-6 lg:mb-0">
              <div class="vs-input--label">Период:</div>
              <VueCtkDateTimePicker
                range
                :label="'Выберите дату'"
                :format="'YYYY-MM-DD'"
                :formatted="'DD.MM.YYYY'"
                :noHeader="true"
                :autoClose="true"
                :onlyDate="true"
                :noLabel="true"
                :noClearButton="true"
                :maxDate="pickerOptions.maxDate"
                :customShortcuts="pickerOptions.customShortcuts"
                v-model="currentFilters.date"
              />
            </div>
            <div class="vx-col w-full lg:w-3/12">
              <vs-button :disabled="buttonIsDisabled" @click.prevent="handleBuild" class="w-full">Построить</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <InfoStatistics
      v-if="showStatistics"
      :key="generatedKey"
      :reports="reports"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { copyObject, compareObjects } from '../../helpers/helpers'
import moment from 'moment'

import ChannelReport from '../../api/http/models/ChannelReport'
import InfoStatistics from './components/InfoStatistics'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  data () {
    return {
      start: false,
      showStatistics: false,
      buttonIsDisabled: true,
      generatedKey: null,

      reports: null,

      channels: [],

      filters: {},

      currentFilters: {
        channel: null,
        date: {
          start: null,
          end: null
        }
      },

      pickerOptions: {
        maxDate: `${moment().subtract(1, 'days').format('YYYY-MM-DD')}`,
        customShortcuts: [
          { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
          { key: 'lastWeek', label: 'Предыдущая неделя', value: '-isoWeek' },
          { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
          { key: 'lastMonth', label: 'Предыдущий месяц', value: '-month' },
          { key: 'thisYear', label: 'Этот год', value: 'year' },
          { key: 'lastYear', label: 'Предыдущий год', value: '-year' }
        ]
      }
    }
  },

  watch: {
    currentFilters: {
      deep: true,
      handler (newVal) {
        this.buttonIsDisabled = !(
          this.currentFilters.channel &&
          this.currentFilters.date.start &&
          this.currentFilters.date.end &&
          !compareObjects(newVal, this.filters)
        )
      }
    }
  },

  computed: {
    ...mapGetters(['authUserCompany']),

    channelSlug () {
      if (this.filters.channel && this.channels) {
        return this.channels.find(channel => channel.slug === this.filters.channel).name
      }
    }
  },

  methods: {
    async handleBuild () {
      await this.$vs.loading()
      this.filters = copyObject(this.currentFilters)
      this.buttonIsDisabled = true

      if (
        this.$route.query.channel !== this.filters.channel ||
        this.$route.query.start !== this.filters.date.start ||
        this.$route.query.end !== this.filters.date.end
      ) {
        this.$router.replace(
          {
            name: 'reports',
            query: {
              channel: this.filters.channel,
              start: this.filters.date.start,
              end: this.filters.date.end
            }
          }
        )
      }

      const response = await ChannelReport.build(this.authUserCompany.slug, {
        channel_slug: this.filters.channel,
        from: this.filters.date.start,
        to: this.filters.date.end
      })

      if (response.data) {
        this.reports = response.data
      }

      this.generatedKey = `${this.filters.channel}.${this.filters.date.start}.${this.filters.date.end}`
      this.showStatistics = true
      this.$vs.loading.close()
    }
  },

  components: {
    InfoStatistics,
    VueCtkDateTimePicker
  },

  async created () {
    const response = await ChannelReport.getChannels(this.authUserCompany.slug)

    if (response.data) {
      this.channels = response.data.reverse()
    }

    if (
      this.$route.query.channel &&
      this.$route.query.start &&
      this.$route.query.end &&
      this.channels.find(channel => channel.slug === this.$route.query.channel) &&
      moment(this.$route.query.start, 'YYYY-MM-DD').isValid() &&
      moment(this.$route.query.end, 'YYYY-MM-DD').isValid()
    ) {
      this.currentFilters.channel = this.$route.query.channel
      this.currentFilters.date.start = this.$route.query.start
      this.currentFilters.date.end = this.$route.query.end
      this.handleBuild()
    }

    this.start = true
  }
}
</script>

<style lang="scss">
  .date-time-picker {
    .field-input {
      min-height: 37px;
      height: 37px;
    }

    .shortcuts-container {
      height: 340px !important;
    }

    .datetimepicker {
      display: none !important;

      &.visible {
        display: block !important;
      }
    }

    .custom-button {
      height: 40px !important;
      transition: .2s ease-in-out !important;

      &:hover {
        background: #9ac8ff;
        color: #fff;
      }

      &.is-selected {
        background: #1d90ff;
      }
    }

    .custom-button-effect {
      display: none !important;
    }
  }
</style>
